import {
  SUBMIT_RENEWAL_REQUEST,
  SUBMIT_RENEWAL_SUCCESS,
  SUBMIT_RENEWAL_FAILURE
} from "../actions/renewalAgentActions";

const initialState = {
  loading: false,
  successMessage: "",
  errorMessage: "",
};

export default function renewalReducer(state = initialState, action) {
  switch (action.type) {
    case SUBMIT_RENEWAL_REQUEST:
      return { ...state, loading: true, successMessage: "", errorMessage: "" };

    case SUBMIT_RENEWAL_SUCCESS:
      return { ...state, loading: false, successMessage: action.payload };

    case SUBMIT_RENEWAL_FAILURE:
      return { ...state, loading: false, errorMessage: action.payload };

    default:
      return state;
  }
}
